import APIClient from '@/shared/http/clients/api'

const resourceName = 'RECliente'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetEmpreendimentoById = (cpf, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetEmpreendimentoById/${cpf}`, data, config)
const GetEmpreendimentoByUnidadeEmpreendimento = (cpf, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetEmpreendimentoByUnidadeEmpreendimento/${cpf}`, data, config)

const REClientRepository = {
  GetEmpreendimentoById,
  GetEmpreendimentoByUnidadeEmpreendimento
}

export default REClientRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/client.js